const NotFoundPage = () => {
    return(
        <div className="flex flex-col mx-auto mt-8">
            <div className="flex flex-col space-y-10">
                    <div className="font-extrabold text-purple-400 text-9xl">
                        404: page not found
                    </div>
            </div>
        </div>
    )
}

export default NotFoundPage